export enum ValidationSchemas {
  ARTICLE = 'article',
  ARTICLE_DISAGREEMENT = 'articleDisagreement',
  BUDGET_RULE = 'budgetRule',
  SETTINGS = 'settings',
  GIFT_ARTICLE = 'giftArticle'
}
